// Rollbar checkIgnore (вынесен из main.js для тестируемости, 2026-07-22).
// Отбрасываем ошибки, в стектрейсе которых НЕТ ни одного нашего фрейма:
// - инъекции браузерных расширений (chrome-extension:// и т.п.), VM-скрипты,
//   <anonymous>/eval — исходная логика;
// - целиком чужие origin'ы (issue #126: client.crisp.chat падал SyntaxError
//   регулярки в старом Safari) — скрипт не наш, чинить нечего. Наш код =
//   webpack:// либо наш хост (rentprog / localhost / Capacitor file://).
// Работает одинаково на web (rentprog.net) и mobile (Capacitor).
export function rollbarCheckIgnore(isUncaught, args, payload) {
  try {
    var body = (payload && payload.body) || {};
    var trace = body.trace || (body.trace_chain && body.trace_chain[0]) || null;
    var frames = (trace && trace.frames) || [];
    if (!frames.length) return false; // стек не распознан → не глушим

    var hasOwnFrame = frames.some(function (f) {
      var fn = f && f.filename ? f.filename : "";
      if (!fn) return false;                                       // eval без источника
      if (/^(chrome|moz|safari|webkit)-extension:\/\//.test(fn)) return false;
      if (/^VM\d+/.test(fn)) return false;                         // динамический скрипт
      if (fn.indexOf("<anonymous>") !== -1) return false;
      if (/^https?:\/\//.test(fn) && !/rentprog|localhost|127\.0\.0\.1/.test(fn)) return false;
      return true;                                                 // фрейм нашего кода
    });
    return !hasOwnFrame; // нашего кода в трейсе нет → игнорируем
  } catch (e) {
    return false; // при любой осечке фильтра — лучше отправить, чем потерять
  }
}
